/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Use_Cases_EyebrowInputs */

const en_directory_taxonomy_use_cases_eyebrow = /** @type {(inputs: Directory_Taxonomy_Use_Cases_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse by use case`)
};

const zh_directory_taxonomy_use_cases_eyebrow = /** @type {(inputs: Directory_Taxonomy_Use_Cases_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按使用场景浏览`)
};

/**
* | output |
* | --- |
* | "Browse by use case" |
*
* @param {Directory_Taxonomy_Use_Cases_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_use_cases_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Use_Cases_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Use_Cases_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_use_cases_eyebrow(inputs)
	return zh_directory_taxonomy_use_cases_eyebrow(inputs)
});
export { directory_taxonomy_use_cases_eyebrow as "directory.taxonomy.use-cases.eyebrow" }